import React from 'react';
import PropTypes from 'prop-types';

const CarouselRender = ({
  handleNavigation,
  imageIds,
  listRef,
  shouldDisplayCount,
  shouldDisplayCaption,
  caption,
  countMessage,
  direction,
  priorityLimit,
  modifier,
  children,
  ...otherProps
}) => (
  <div className={`carousel ${modifier}`}>
    <div>
      <div
        className="carousel__button carousel__button--previous"
        role="button"
        aria-label="Previous Slide"
        onClick={() => handleNavigation(direction.back)}>
        <div className="arrow arrow--left" />
      </div>
      <div className="carousel__list" ref={listRef}>
        {children}
      </div>
      <div
        className="carousel__button carousel__button--next"
        role="button"
        aria-label="Next Slide"
        onClick={() => handleNavigation(direction.next)}>
        {shouldDisplayCount && <p data-testid="count">{countMessage}</p>}
        <div className="arrow arrow--right" />
      </div>
    </div>
    {shouldDisplayCaption && (
      <div className="carousel__details" data-testid="carousel-details">
        <div className="caption">{caption}</div>
      </div>
    )}
  </div>
);

CarouselRender.propTypes = {
  caption: PropTypes.string,
  shouldDisplayCaption: PropTypes.bool.isRequired,
  imageIds: PropTypes.array,
  displayCount: PropTypes.bool,
  listRef: PropTypes.object,
  countMessage: PropTypes.number,
  direction: PropTypes.object.isRequired,
  handleNavigation: PropTypes.func.isRequired,
  shouldDisplayCount: PropTypes.bool.isRequired,
  priorityLimit: PropTypes.number,
  CarouselImage: PropTypes.func.isRequired,
  modifier: PropTypes.string
};

CarouselRender.defaultProps = {
  listRef: null,
  imageIds: [],
  caption: '',
  displayCount: false,
  countMessage: null,
  priorityLimit: 0,
  modifier: ''
};

export default CarouselRender;
